// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraRadioButtonTemplate from '@front/templates/TerceraRadioButtonTemplate.html';
import { Control } from './Control';
export class TerceraRadioButton extends Control {
    constructor() {
        super();
    }
    oncomplete() {
        // this.observe('checked', this.private_OnCheckedChanged);
        // this.on('radioBtnClick', this.private_RadioClick);
    }
    oninit() {
        super.oninit();
        this.observe('checked', this.private_OnCheckedChanged);
        this.on('radioBtnClick', this.private_RadioClick);
    }
    private_RadioClick(me) {
        if (!me.checked) {
            void this.set('checked', true);
        }
    }
    private_OnCheckedChanged(newValue, oldValue, keypath) {
        if (!newValue && !oldValue) {
            return;
        }
        this.fire(RadioButtonEvents.RadioBtnStateChange, this, newValue, oldValue);
    }
}
var RadioButtonEvents;
(function (RadioButtonEvents) {
    RadioButtonEvents["RadioBtnStateChange"] = "RBStateChange";
})(RadioButtonEvents || (RadioButtonEvents = {}));
Control.extendWith(TerceraRadioButton, {
    template: TerceraRadioButtonTemplate,
    data: function () {
        return {
            checked: false,
            text: ''
        };
    }
});
